import axios from "axios";
import { defineStore } from "pinia";

export const useTagStore = defineStore("tag", {
  state: () => ({
    apiUrl: process.env.VUE_APP_API_URL,
    tags: [],
    response: {
      status: null,
      message: null,
      list: [],
    },
    nameQuery: "",
    current: 1,
    perpage: 25,
    totalData: 0,
  }),
  actions: {
    async changePage(newPage) {
      this.current = newPage;
    },

    async searchUsers(query) {
      this.nameQuery = query;
      this.current = 1;
    },

    async getTags(current) {
      const params = new URLSearchParams({
        current: current ? current : this.current,
        per_page: this.perpage,
      });

      if (this.nameQuery) params.append("name", this.nameQuery);
      if (this.slugQuery) params.append("slug", this.slugQuery);

      try {
        const res = await axios.get(`${this.apiUrl}/api/v1/tags`, {
          params,
        });

        this.tags = res.data.data.list;
        this.totalData = res.data.data.meta.total;
      } catch (error) {
        this.response = {
          status: error.response?.status,
          message: error.message,
        };
      }
    },

    async addTag(data) {
      try {
        const res = await axios.post(`${this.apiUrl}/api/v1/tags`, data);

        this.response = {
          status: res.status,
          message: res.data.message,
        };

        return res.data.data;
      } catch (error) {
        this.response = {
          status: error.response?.status,
          message: error.message,
          list: error.response.data.errors,
        };
      } 
    },

    async updateTag(data) {
      try {
        await axios.put(`${this.apiUrl}/api/v1/tags`, data);

        this.response = {
          status: "200",
        };
      } catch (error) {
        this.response = {
          status: error.response?.status,
          message: error.message,
          list: error.response.data.errors,
        };
      }
    },

    async deleteTag(id) {
      try {
        const res = await axios.delete(
          `${this.apiUrl}/api/v1/tags/${id}`
        );

        this.response = {
          status: res.status,
          message: res.data.message,
        };
      } catch (error) {
        this.response = {
          status: error.response?.status,
          message: error.message,
          list: error.response.data.errors,
        };
      }
    },
  },
});
